export type PersonalizationOffersPayload = Record<string, unknown>;

export const DEFAULT_PERSONALIZATION_PAYLOAD: PersonalizationOffersPayload = {
  logo: '',
  status: 'valid',
  profileFrameId: '',
  playerLevelName: '',
  bannerExternalId: '',
  playerLevel: {
    assetId: '',
    text: '',
    endsIn: 0
  },
  playerLevelBanners: [],
  sectionsOrder: [],
  segments: [],
  focus: {
    publisherBundleId: ''
  },
  storeTheme: {
    bgImageMobile: '',
    bgImageDesktop: '',
    logo: '',
    profileFrameImage: '',
    bannerImage: '',
    playerLevelImage: ''
  },
  balances: [],
  offers: []
};

export const getDefaultPersonalizationJson = (): string => {
  return JSON.stringify(DEFAULT_PERSONALIZATION_PAYLOAD, null, 2);
};

export const parsePersonalizationJson = (
  json: string | undefined
): PersonalizationOffersPayload | null => {
  if (!json) return null;

  try {
    return JSON.parse(json) as PersonalizationOffersPayload;
  } catch {
    return null;
  }
};
